import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Spinner from "../common/spinner";
import { ToastContainer, toast } from "react-toastify";
import * as service from "././activeBundlesServices";
import {
    timestampToDateYearAndTime,
    log,
} from "../../helper/helper";

function ActiveBundles(props) {
    const [transports, setTransports] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isHidden, setBtnHidden] = useState(false);
    const [cursorTransportId, setCursorTransportId] = useState("");

    useEffect(() => {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (!user) {
                return props.history.replace("/login");
            }
            adminGetAllActiveBundledTransports("");
        });
    }, []);

    const handleTransportDate = (time) => {
        return timestampToDateYearAndTime(time._seconds, time._nanoseconds);
    };

    const adminGetAllActiveBundledTransports = async (id) => {
        setLoading(true);
        try {
            const result = await service.adminGetAllActiveBundledTransports(id);
            setLoading(false);
            log(result);
            if (result) {
                setLoading(false);
                switch (result.data.code) {
                    case 200:
                        if (id === "") {
                            setTransports(result.data.bundleList);
                        } else {
                            const list = [...transports, ...result.data.bundleList];
                            setTransports(list);
                        }

                        if (result.data.cursor_transport_id) {
                            setCursorTransportId(result.data.cursor_transport_id);
                            setBtnHidden(false);
                        } else {
                            setCursorTransportId("");
                            setBtnHidden(true);
                        }

                        return;
                    case 401:
                        toast.error(result.data.message);
                        return props.history.replace("/login");
                    case 500:
                        return toast.error(result.data.message);
                    default:
                        return toast.error(result.data.message);
                }
            }
        } catch (error) {
            log(error);
            toast.error(error.message);
        }
        setLoading(false);
    };

    const renderSpinner = () => (isLoading ? <Spinner /> : null);

    return (
        <div className="show-all-list data-server-list bundle-transport">
            <ToastContainer />
            {renderSpinner()}

            <h6>
                Found {transports.length} {transports.length > 1 ? "results" : "result"}
            </h6>

            {transports.length > 0 && (
                <>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Bundle No.</th>
                                <th>Starting Address</th>
                                <th>Finish Address</th>
                                <th>Total Time to Complete</th>
                                <th>Total Travelling Distance</th>
                                <th>Payable to Bearer</th>
                                <th>(More Details)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transports.map((transport) => (
                                <tr key={transport.order_number}>
                                    <td>{handleTransportDate(transport.bundle_create_time)}</td>
                                    <td>{transport.order_number}</td>
                                    <td>{transport.shortened_first_origin_address}</td>
                                    <td>{transport.shortened_last_destination_address}</td>
                                    <td>{transport.bundle_time}</td>
                                    <td>{transport.bundle_length}</td>
                                    <td>{"A$ " + transport.bundle_final_paid_to_rider}</td>
                                    <td>
                                        <button className="single-view"
                                            onClick={() => {
                                                props.history.push("/home/bundledOrderSingle", {
                                                    orderNumber: transport.order_number,
                                                    isComeFromActiveBundle: true,
                                                });
                                            }}
                                        >
                                            view
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="load-more">
                        <ul style={{ margin: 0 }}>
                            {!isHidden && (
                                <li>
                                    <button
                                        onClick={() =>
                                            adminGetAllActiveBundledTransports(cursorTransportId)
                                        }
                                    >
                                        Load More
                                    </button>
                                </li>
                            )}
                        </ul>
                    </div>
                </>
            )
            }
        </div >
    );
}

export default ActiveBundles;
